/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteCategoryCommand } from '../../models/delete-category-command';
import { DeleteCategoryCommandResult } from '../../models/delete-category-command-result';

export interface ApiNurseryManagerCategoryDeleteCategoryDelete$Plain$Params {
      body?: DeleteCategoryCommand
}

export function apiNurseryManagerCategoryDeleteCategoryDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerCategoryDeleteCategoryDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteCategoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerCategoryDeleteCategoryDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteCategoryCommandResult>;
    })
  );
}

apiNurseryManagerCategoryDeleteCategoryDelete$Plain.PATH = '/api/NurseryManager/Category/DeleteCategory';
